<template>
	<div>
	  <div v-show="phone" class="afsc_about" @click="foothide()">
	  	<div class="afse_video">
	  		<video id="my_video" loop class=" video-js vjs-default-skin vjs-fluid " autoplay preload="auto" width="100%" poster="../assets/asfc.png" data-setup="{}">
	  			<source src="" type='video/mp4'>
	  			<source src="../assets/afscvideo.mp4" type='video/mp4'>
	          您的浏览器版本过低不支持 video 标签。
	  		</video>
	  		<div class="dv_bg"></div>
	  		<div v-if="lang" class="div_img">
	  			<img src="../assets/afsc_icon.png" alt="">
	  		</div>
	  		<div v-else class="div_img">
	  			<img src="../assets/afsc_icon_3.png" alt="">
	  		</div>
	  	</div>
	    <div class="afsc_person">
	    	<p v-if="lang"><span class="english">AFSC </span>厂牌艺人</p>
	    	<p v-else class="english"><span class="english">AFSC </span>Artist</p>
	    	<div class="person_one">
	    		<div>
	    			<div class="afsc_vio">
	            <div id="video_one">
	              <video id="my_video_1" class="video-js vjs-default-skin vjs-fluid " controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
	                <source src="" type='video/mp4'>
	                <source src="../assets/person/fl.mp4" type='video/mp4'>
	                  您的浏览器版本过低不支持 video 标签。
	              </video>
	            </div>
	            <img class="afsc_img" :style="{display:show}" src="../assets/person/person_1.jpg" alt="">
	            <img class="afsc_btn" v-show="play_flag" @click="play_one()" src="../assets/play_btn.png" alt="">
	          </div>
	    			<div>
	    				<p>
	    					<span v-if="lang">法老</span>
								<span class="english" v-else>Pharaoh</span>
	    				</p>
	    				<p>
	    					<span v-if="lang">
	    						上海<span class="english">HIPHOP</span>音乐人，作为当今最有实力的<span class="english">Rapper</span>之一 ,被称为中国嘻哈硬核说唱的代表人物。
								但他从不局限于某一种风格，在创作中不断突破与重塑，用丰富的舞台表现、舞台视觉与听觉的完美结合
								将爆炸的现场，呈现在每一位听众的眼前、耳边，将当代年轻人爱拼、爱玩、爱挑战的精神体现的淋漓尽致。
	    					</span>
	    					<span class="english" v-else>
	    						Pharaoh, the Chinese famous hardcore rapper, now living in Shanghai. He is never confined to a certain style, always breaking through himself in his creation.
								Rich stage performance, the perfect combination of stage vision and hearing, the explosive scene, present for every audience. As the contemporary young people, heincisively and vividly shows the love to challenge, love to play.
	    					</span>
	    				</p>
	    				<p v-if="lang">专辑</p>
	    				<p v-else>Album</p>
	    				<p><span class="english">ONLY ONE</span></p>
	    				<p>如果死亡将要来临</p>
	    				<p>日字冲拳<span class="english">(freestyle)</span></p>
	    				<p><span class="english">respect</span></p>
	    				<p><span class="english">GUCCI GANG REMIX</span></p>
	    				<p>独行侠</p>
	    			</div>
	    		</div>
	    		<div>
	          <div class="afsc_vio">
	            <div id="video_two">
	              <video id="my_video_2" class="video-js vjs-default-skin vjs-fluid " controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
	                <source src="" type='video/mp4'>
	                <source src="../assets/person/TOY_1.mp4" type='video/mp4'>
	                  您的浏览器版本过低不支持 video 标签。
	              </video>
	            </div>
	            <img class="afsc_img" :style="{display:show2}" src="../assets/person/person_2.jpg" alt="">
	            <img class="afsc_btn" v-show="play_flag2" @click="play_two()" src="../assets/play_btn.png" alt="">
	          </div>
	    			<div>
	    				<p>
	    					<span v-if="lang">
	    						<span class="english">TOY</span> 王奕
	    					</span>
	    					<span v-else>
	    						<span class="english">TOY_Wong</span>
	    					</span>
	    				</p>
	    				<p>
	    					<span v-if="lang">
	    						来自湖南长沙的<span class="english">HIPHOP</span>歌手，现居上海，从<span class="english">B-Boy</span>舞者的执着到中文说唱音乐的启蒙<span class="english">Toy Wong</span>注定走上属于自己独特的嘻哈人生。
								歌曲内容的态度表达，未曾受到外界物质世界的干扰而保持真实的自我，使他在近年来受到大量乐迷群体的喜爱。
	    					</span>
	    					<span class="english" v-else>
	    						Toy Wong，a rapper from Changsha, Hunan Province, now lives in Shanghai. From a B-Boy to a rapper,he is destined to embark on his own unique hip-hop life.
								His attitude towards the content of the song, his true self without being disturbed by the outside world, has made him popular with a large number of fans in recent years.
	    					</span>
	    				</p>
	    				<p v-if="lang">专辑</p>
	    				<p class="english" v-else>Album</p>
	    				<p>那一天</p>
	    				<p><span class="english">Coming now</span></p>
	    				<p><span class="english">My Birthday</span></p>
	    				<p><span class="english">City To City</span></p>
	    				<p>路子</p>
	    				<p><span class="english">1993</span></p>
	    			</div>
	    		</div>
	    		<div>
	    			<div class="afsc_vio">
	            <div id="video_three">
	              <video id="my_video_3" class="video-js vjs-default-skin vjs-fluid " controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
	                <source src="" type='video/mp4'>
	                <source src="../assets/person/wy.mp4" type='video/mp4'>
	                  您的浏览器版本过低不支持 video 标签。
	              </video>
	            </div>
	            <img class="afsc_img" :style="{display:show3}" src="../assets/person/person_3.jpg" alt="">
	            <img class="afsc_btn" v-show="play_flag3" @click="play_three()" src="../assets/play_btn.png" alt="">
	          </div>
	    			<div>
	    				<p>
	    					<span v-if="lang">王愚</span>
								<span class="english" v-else>
									Pavel
								</span>
	    				</p>
	    				<p>
	    					<span v-if="lang">
	    						王愚来自于上海的说唱歌手，同事也是音乐制作人、混音师，现居上海。<span class="english">2016</span>年独立发表个人首张<span class="english">EP</span>《她》在王愚过往发表的作品中，除个别曲目之外，王愚几乎一人担当词曲编曲混音等工作，为华语嘻哈为数不多的全能型音乐创作人之一，被誉为“说唱王羲之”。
	    					</span>
	    					<span class="english" v-else>
	    						Pavel is a rapper from Shanghai. He is also a music producer. In 2016, the first individual EP "she" was released. Except a few pieces, Pavel almost acted as a composer,mixer and producer. He is one of the few all-round artists of Chinese hip-hop, known as “Wang Xizhi of Rap".
	    					</span>
	    				</p>
	    				<p v-if="lang">专辑</p>
	    				<p v-else>Album</p>
	    				<p>她 <span class="english">Part ll</span></p>
	    				<p>他</p>
	    				<p><span class="english">Guess What</span></p>
	    				<p><span class="english">Merry Christmas</span></p>
	    				<p><span class="english">Sensitive:The Pavel Beat Tape</span></p>
	    				<p><span class="english">Fresh</span></p>
	    			</div>
	    		</div>
	    		<div>
	    			<div class="afsc_vio">
	            <div id="video_four">
	              <video id="my_video_4" class="video-js vjs-default-skin vjs-fluid " controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
	                <source src="" type='video/mp4'>
	                <source src="../assets/person/LJ.mp4" type='video/mp4'>
	                  您的浏览器版本过低不支持 video 标签。
	              </video>
	            </div>
	            <img class="afsc_img" :style="{display:show4}" src="../assets/person/person_4.jpg" alt="">
	            <img class="afsc_btn" v-show="play_flag4" @click="play_four()" src="../assets/play_btn.png" alt="">
	          </div>
	    			<div>
	    				<p><span class="english">LIL.JET</span></p>
	    				<p>
	    					<span v-if="lang">
	    						<span class="english">LIL.JET</span> 陆政廷<span class="english">2001</span>年出生，来自广东深圳的<span class="english">HIPHOP/R&B</span>音乐唱作人，从<span class="english">7</span>岁起接触音乐，有丰富的舞台经验接触说唱已有6年时间。现居上海，作为一个00后新锐说唱歌手却拥有超越年龄的磁性声线从歌曲里透露出的放荡不羁只有现场倾听才能感同身受。
	    					</span>
	    					<span v-else class="english">
	    						Lil.Jet was born in 2001,a HIPHOP/R&B artist from Shenzhen, Guangdong. He contacted musicfrom the age of 7, has rich experience in stage. Now he is living in Shanghai. As a young rapper born after 2000, he has a magnetic voicenot like his age.Only at the scene, people can feel his talents.
	    					</span>
	    				</p>
	    				<p v-if="lang">专辑</p>
	    				<p v-else>Album</p>
	    				<p><span class="english">Venus</span></p>
	    				<p>萬聖節</p>
	    				<p>说句实话<span class="english">(prod.10k)</span></p>
	    				<p>鹰</p>
	    				<p><span class="english">JET</span>式病毒</p>
	    				<p>自我介绍</p>
	    			</div>
	    		</div>
	    		<div>
	    			<div class="afsc_vio">
	            <div id="video_five">
	              <video id="my_video_5" class="video-js vjs-default-skin vjs-fluid " controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
	                <source src="" type='video/mp4'>
	                <source src="../assets/person/has.mp4" type='video/mp4'>
	                  您的浏览器版本过低不支持 video 标签。
	              </video>
	            </div>
	            <img class="afsc_img" :style="{display:show5}" src="../assets/person/person_5.jpg" alt="">
	            <img class="afsc_btn" v-show="play_flag5" @click="play_five()" src="../assets/play_btn.png" alt="">
	          </div>
	    			<div>
	    				<p><span class="english">HA$</span></p>
	    				<p>
	    					<span v-if="lang">
	    						<span class="english">HA$</span>来自中国西部新疆的<span class="english">HIPHOP</span>组合，现居上海，来自中国西部新疆，成员都为新疆早期地下知名说唱歌手，<span class="english">2015</span>年首次以团队<span class="english">HA$</span>的名义发布<span class="english">mv</span>《<span class="english">Sow-ghatliq Ketmen</span>》而名声大噪，并以此作品荣获<span class="english">2015</span>年度北京电影学院学院奖短片大赛（原金鸡百花学院奖短片大赛）“观众最喜爱的短片”奖及入围“柏林华语电影节”青年单元提名。一直受热捧的他们今年夏天又以<span class="english">Trap mv</span> 《<span class="english">OYNIMA</span>》红到抽搐！曝光量近百万

	    						
	    					</span>
	    					<span class="english" v-else>
	    						HA$is a rap team from Xinjiang in Western China, now living in Shanghai. members are the early well-known underground rapper in Xinjiang. In 2015, they released MV "Sowghatliq Ketmen" and got much attention. They won the 2015 Beijing Film University Awards and were nominated by the youth unit of the Berlin Chinese Film Festival. As an always popular rap team, they were foucused again by the Trap mv“OYNIMA”, getting almost 1 million views.
	    					</span>
	    				</p>
	    				<p v-if="lang">专辑</p>
	    				<p v-else>Album</p>
	    				<p><span class="english">Gucci&乌鲁木齐</span></p>
	    				<p><span class="english">H.G.O.D.W</span></p>
	    				<p>定时闹钟</p>
	    				<p>很高兴见到你</p>
	    				<p><span class="english">One</span></p>
	    			</div>
	    		</div>
	    	</div>
	    </div>
	    <div id="person_1" class="afsc_person_1">
				<p v-if="lang"><span class="english">AFSC 2017</span>全国巡演回顾</p>
				<p v-else class="english">AFSC 2017 China tour review</p>
				<div v-show="lang" class="afsc_main">
		      <div>
		        <embed src="https://imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400&v=20161117&vid=o0534a31239&auto=0" allowFullScreen="true" quality="high" width="480" height="400" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash"></embed>
		      </div>
				</div>
		    <div v-show="!lang" class="afsc_main">
		      <div><iframe width="646" height="393" src="https://www.youtube.com/embed/GEcz4jm0fhU" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>
		    </div>
	    </div>
	  	<div class="afsc_person_2">
	  		<p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有©2016【 沪ICP备16032276号 】</p>
	      <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved©2016[Shanghai ICP no. 16032276]</p>
	      <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	      <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
	  	</div>
	  	<transition name="mybox">
		  	<div  class="footer" v-show="fot_show"  @click.stop="footShow()">
					<div><span v-if="lang">邮箱：</span><span v-else class="english">email: </span><span class="english">fxh@fangxuehai.cc</span></div>
	        <div>
	          <span v-if="lang">地址：上海市 杨浦区 军工路 100号 18栋 放学嗨</span>
	          <span v-else class="english">address: Afterschool, Building 18，No. 100, Jungong Road, Yangpu District, Shanghai</span>
	        </div>
					<div v-on:click="link_to()" class="link_to">
	          <img src="../assets/sina_logo.png" alt="">
	          <span v-if="lang"> 放学嗨</span>
	          <span v-else class="english"> Afterschool</span>
	        </div>
	        <div>
	          <div>
	            <p><img src="../assets/wx_fxh.jpg" alt=""></p>
	            <p><img src="../assets/wx_logo.png" alt=""><span v-if="lang"> 放学嗨</span>
	          <span v-else class="english"> Afterschool</span></p>
	          </div>
	          <div>
	            <p><img src="../assets/wx_afsc.jpg" alt=""></p>
	            <p><img src="../assets/wx_logo.png" alt=""><span class="english"> AFSC</span></p>
	          </div>
	        </div>
					<div class="afsc_person_2">
			  		<p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有©2016【 沪ICP备16032276号 】</p>
	          <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved©2016[Shanghai ICP no. 16032276]</p>
	          <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	          <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
			  	</div>
		  	</div>
	  	</transition>
	  	<div id="click_btn" @click.stop="footShow()" class="phone_us" :style="{border: '2px solid #' + bordercolor,backgroundColor: '#' + bgcolor,color: '#' + bordercolor}">
	  		<span v-if="lang">联系我们</span>
	      <span v-else class="english">Contact us</span><span :style="{backgroundColor:'#'+bordercolor}"></span>
	  	</div>
	  </div>
	  <div v-show="!phone" class="phone_afsc">
	  	<phone_afsc :lang="lang"></phone_afsc>
	  </div>
	 </div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import phone_afsc from './phone_afsc'

export default {
  name: 'AFSCAbout',
  components: {
  	phone_afsc,
  },
  props:["lang"],
  data () {
    return {
      msg: '44',
      ost_top: '',
      person_top: '',
      bordercolor: 'FFFB00',
      bgcolor: '000000',
      fot_show: false,
      scrollTop: 0,
      flag: true,
      video_one: '',
      play_flag: true,
      show: 'inline-block',
      video_two: '',
      play_flag2: true,
      show2: 'inline-block',
      video_three: '',
      play_flag3: true,
      show3: 'inline-block',
      video_four: '',
      play_flag4: true,
      show4: 'inline-block',
      video_five: '',
      play_flag5: true,
      show5: 'inline-block',
      phone: true
    }
  },
  methods: {
  	handleScroll () {
  		this.scrollTop = window.pageYOffset  //用于FF
            || document.documentElement.scrollTop
            || document.body.scrollTop
            || 0;
  		this.ost_top = document.getElementById('click_btn').offsetTop + this.scrollTop;
  		this.person_top = document.getElementById('person_1').offsetTop
  		if ( this.flag == true  ) {
  			if ( this.ost_top > this.person_top ) {
	  			this.bordercolor = '000000'
	  			this.bgcolor = 'FFFB00'
	  		}else {
	  			this.bordercolor = 'FFFB00'
	  			this.bgcolor = '000000'
	  		}
  		}
  	},
  	footShow () {
  		this.fot_show = !this.fot_show;;
      this.flag = false;
      if ( this.fot_show == false ) {
        if ( this.ost_top > this.person_top ) {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        }else {
          this.bordercolor = 'FFFB00'
          this.bgcolor = '000000'
          setTimeout(() => {
            this.bordercolor = 'FFFB00'
            this.bgcolor = '000000'
          },200);
        }
        this.flag = true;
      }else {
        setTimeout(() => {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        },200);
      }
  	},
  	foothide () {
  		this.fot_show = false;
  		this.flag = true;
  		this.bordercolor = 'FFFB00'
  		this.bgcolor = '000000'
  		this.ost_top = document.getElementById('click_btn').offsetTop + this.scrollTop;
  		this.person_top = document.getElementById('person_1').offsetTop
  		if ( this.ost_top > this.person_top ) {
  			this.bordercolor = '000000'
  			this.bgcolor = 'FFFB00'
  		}else {
  			this.bordercolor = 'FFFB00'
  			this.bgcolor = '000000'
  			setTimeout(() => {
		  		this.bordercolor = 'FFFB00'
	  			this.bgcolor = '000000'
      },200);
  		}
  	},
    link_to () {
      window.location.href="https://weibo.com/u/5692890069?refer_flag=1001030101_&is_hot=1"
    },
    play_one () {
      this.show = 'none';
      this.play_flag = false;
      this.video_one.play();
    },
    play_two () {
      this.show2 = 'none';
      this.play_flag2 = false;
      this.video_two.play();
    },
    play_three () {
      this.show3 = 'none';
      this.play_flag3 = false;
      this.video_three.play()
    },
    play_four () {
      this.show4 = 'none';
      this.play_flag4 = false;
      this.video_four.play()
    },
    play_five () {
      this.show5 = 'none';
      this.play_flag5 = false;
      this.video_five.play()
    },
    play_six () {
      this.show6 = 'none';
      this.play_flag6 = false;
      this.player_six.play(this.video_six)
    },
	  IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  mounted () {
  	this.phone = this.IsPC();
    if ( this.phone == true ) {
	
	    document.getElementById('ayo_icon').style.display = "inline-block";
	    document.getElementById('ayo_icon_2').style.display = "none";
	    document.getElementById('afsc_icon').style.display = "none";
	    document.getElementById('afsc_icon_2').style.display = "inline-block";
	  	videojs(document.getElementById('my_video'))
	    this.video_one = videojs(document.getElementById('my_video_1'))
	    this.video_two = videojs(document.getElementById('my_video_2'))
	    this.video_three = videojs(document.getElementById('my_video_3'))
	    this.video_four = videojs(document.getElementById('my_video_4'))
	    this.video_five = videojs(document.getElementById('my_video_5'))
	
	  	this.ost_top = document.getElementById('click_btn').offsetTop
	  	console.log(this.ost_top);
	  	window.addEventListener('scroll', this.handleScroll)
    }else {
    	
    }

    // this.video_six = new tvp.VideoInfo();
    // this.video_six.setVid("o0534a31239");//视频vid
    // this.player_six = new tvp.Player();//视频高宽646, 393
    // this.player_six.create({
    //   width: 646,
    //   height: 393,
    //   video: this.video_six,
    //   modId: "video_six",
    //   pic: "http://fhy1234.applinzi.com/dist/static/img/ayo_vio.4c014bb.jpg", //视频封面地址
    //   vodFlashSkin: "http://imgcache.qq.com/minivideo_v1/vd/res/skins/TencentPlayerMiniSkin.swf", //精简皮肤
    //   autoplay: false, //是否自动播放
    //   onallended:function(){
    //     this.play_flag6 = !this.play_flag6;
    //   }.bind(this),
    //   onpause:function() {
    //     this.play_flag6 = false;
    //   }.bind(this),
    //   onplaying: function() {
    //     this.play_flag6 = false;
    //   }.bind(this),
    //   oninited: function() {
    //     this.play_flag6 = true;
    //   }.bind(this)
    // });
  },
  destroyed () {
  	window.removeEventListener('scroll', this.handleScroll)
	}
}

  	/*document.body.onmousewheel = function(event) {
	    var ost_top = document.body.scrollTop - document.getElementById('click_btn').offsetTop
	    console.log(ost_top);
	};
	document.body.addEventListener("DOMMouseScroll", function(event) {
	    var ost_top = document.body.scrollTop - document.getElementById('click_btn').offsetTop
	    console.log(ost_top);
	});*/
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

	.afsc_about {
		background-color: #000000;
  		min-width: 980px;
	}

	.afse_video {
		width: 100%;
		position: relative;
		left: -12%;
		.dv_bg {
			position: absolute;
			top: 0;
			width: 100%;
			height: 100%;
			background-color: #000000;
			opacity: 0.5;
		}
		.div_img {
			position: absolute;
			left: 12%;
			width: 100%;
			top: 50%;
			transform: translateY(-50%);
			img {
				width: 70%;
			}
		}
	}

	.afsc_person {
		background-color: #000000;
		&>p {
			margin: 0;
			width: 100%;
			color: #FFFB00;
			padding-top: 35px;
			font-family: Heavy;
			font-size: 26px;
			text-align: center;
			margin-bottom: 50px;
		}
	}

	.person_one {
		width: 100%;
		&>div {
			display: flex;
			justify-content: center;
			margin-bottom: 180px;
			&>div:nth-child(1) {
				margin: 0 48px 0px 0;
			}
      .afsc_vio {
        position: relative;
        &>div {
          border: 10px solid #FFFC01;
          width: 512px;
          height: 512px;
          overflow: hidden;
          .video-js {
            height: 100%;
          }
          video {
            height: 100%;
          }
        }
      }
			&>div {
        .afsc_btn {
          position: absolute;
          left: 25px;
          bottom: 27px;
          &:hover {
            cursor: pointer;
          }
        }
				.afsc_img {
          position: absolute;
          left: 0;
          top: 0;
					width: 532px;
          height: 532px;
				}
				p {
					margin: 0;
					width: 320px;
					text-align: left;
					color: #FFFB00;
					font-family: Regular;
				}

			}
			&>div:nth-child(2) {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				&>p:nth-child(1) {
					font-size: 48px;
					line-height: 47px;
					font-family: Heavy;
					color: #FFFB00;
				}
				&>p:nth-child(2) {
					color: #D7D400;
					margin-bottom: 10px;
					letter-spacing: 1px;
					text-align:justify;
				}
				&>p:nth-child(n+2) {
					font-size: 14px;
				}
        &>p:nth-child(3) {
          font-size: 28px;
					font-family: Heavy;
          font-weight: bold;
        }
			}
		}
	}
	.afsc_person_1 {
		width: 100%;
		background-color: #FFFB00;
		padding-bottom: 20px;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
	    padding-top: 35px;
	    font-family: Heavy;
	    font-size: 24px;
	    text-align: center;
	    margin-bottom: 50px;
		}
		div {
			margin-bottom: 100px;
		}
	}
	.afsc_person_2 {
		width: 100%;
		background-color: #FFFB00;
		padding-bottom: 20px;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
			font-family: Regular;
			font-size: 12px;
			text-align: center;
		}
	}

	.phone_us {
		position: fixed;
		bottom: 100px;
		left: 160px;
		text-align: left;
		width: 100px;
		padding-left: 3px;
		font-family: Regular;
		height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
		font-size: 14px;
		z-index: 100;
		&:hover {
			cursor: pointer;
		}
		span:nth-child(2) {
			display: inline-block;
			width: 3px;
			height: 3px;
			margin-left: 35px;
			margin-bottom: 1.5px;
			vertical-align: middle;
			border-radius: 50%;
		}
	}

	.footer {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 380px;
		background: #FFFB00;
		padding-top: 10px;
		p {
			margin: 0;
		}
		&>div:nth-child(-n+3) {
			color: #000000;
			margin-top: 20px;
			margin-bottom: 20px;
			height: 20px;
			line-height: 20px;
		  font-family: Heavy;
		}
		&>div:nth-child(3) {
			span {
				display: inline-block;
				padding-top: 5px;
				vertical-align: top;
		  }
		}
		&>div:nth-child(4) {
			display: flex;
			margin-top: 40px;
			margin-bottom: 40px;
			justify-content: center;
			&>div:first-child {
				margin-right: 80px;
			}
			span {
				color: #000000;
				display: inline-block;
		  	font-family: Heavy;
				vertical-align: top;
		  }
		}
	}

	.mybox-leave-active,.mybox-enter-active{
      transition:  all 1s ease;
  }

  .mybox-leave-active,.mybox-enter{
      height:0px !important;
  }

  .mybox-leave,.mybox-enter-active {
      height: 380px;
  }

  .afsc_main {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 413px;
    .afsc_main_btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      &:hover {
        cursor: pointer;
      }
    }
    .afsc_main_vio {
      position: absolute;
      width: 666px;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      height: 413px;
    }
    div {
      margin: 0 auto;
      border: 10px solid #FFFC01;
      width: 646px;
      height: 393px;
      overflow: hidden;
      embed {
        width: 100%;
      }
    }
  }
	
	.phone_afsc {
		width: 100%;
	}

</style>



// WEBPACK FOOTER //
// src/components/AFSCAbout.vue